<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import type { EventCellClicked } from "./event_types";
	import type { GameCell } from "./game";

	export let cell: GameCell;

	let classes: string[];
	$: {
		classes = [];
		if (cell) {
			if (cell.isHidden) classes.push('hidden');
			if (cell.isBomb) classes.push('bomb');
			if (cell.isMarked) classes.push('marked');
			if (cell.isMistake) classes.push('mistake');

			if (cell.count) {
				classes.push('count');
				classes.push('count-' + cell.count);
			}
		}
	}

	const fireCellClicked = createEventDispatcher<EventCellClicked>();
	const clicked = (setMark: boolean = false): any => fireCellClicked('cell_clicked', {cell, setMark});
</script>

<div class="{classes.join(' ')}"
     on:click="{() => clicked()}"
     on:contextmenu|preventDefault="{() => clicked(true)}">
</div>

<style>
	div {
		border: 1px solid #c9c9c9;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: default;
		background-color: #f5f5f5;
	}

	.bomb { background-color: #555 }
	.bomb::before {
		content: 'B';
		color: #eee;
		font-weight: bold;
	}
	.bomb.mistake::before { color: red }

	.count:where(.count-1, .count-5) { color: blue }
	.count:where(.count-2, .count-6) { color: darkgreen }
	.count:where(.count-3, .count-7) { color: darkred }
	.count:where(.count-4, .count-8) { color: darkcyan }

	.count-1::before { content: '1' }
	.count-2::before { content: '2' }
	.count-3::before { content: '3' }
	.count-4::before { content: '4' }
	.count-5::before { content: '5' }
	.count-6::before { content: '6' }
	.count-7::before { content: '7' }
	.count-8::before { content: '8' }

	.hidden { background-color: #d9d9d9 }
	.hidden::before { content: '' }

	.marked::before {
		content: 'F';
		color: red;
		font-weight: bold;
		padding-left: 6px;
		padding-right: 6px;
		background-color: #ff0;
	}

	.marked.mistake { background-color: #faa }
</style>
